import { render, staticRenderFns } from "./remingtonSeedsHeader.vue?vue&type=template&id=b40f2f4e&scoped=true"
import script from "./remingtonSeedsHeader.vue?vue&type=script&lang=js"
export * from "./remingtonSeedsHeader.vue?vue&type=script&lang=js"
import style0 from "./remingtonSeedsHeader.vue?vue&type=style&index=0&id=b40f2f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40f2f4e",
  null
  
)

export default component.exports